// @flow
import * as React from 'react';
import Radium from 'radium';
import moment from 'moment';

import IconText from 'components/IconText';

import { Colors, Spacing } from 'utils/styleguide';
import { ellipsify } from 'utils/text';
import ENV from 'environment';

type Props = {
  title: string,
  description: string,
  image?: string,
  createdAt: number,
  likesCount?: number,
  commentsCount?: number,
  statusComponent?: React.Node,
};
const IMAGE_WIDTH = 256;
const IMAGE_HEIGHT = 144;

class ImageTextListItem extends React.Component<Props> {
  render() {
    const {
      title,
      description,
      image,
      statusComponent,
      createdAt,
      likesCount,
      commentsCount,
    } = this.props;

    const backgroundImageUrl =
      image && image.startsWith('https://')
        ? image
        : `${ENV.HOST}/images/${image}`;

    return (
      <div style={styles.root}>
        <div style={styles.content}>
          {/* <div
            style={[
              styles.imageWrapper,
              !image && styles.imageWrapperMissing,
              !!image && {
                backgroundImage: `url(${backgroundImageUrl})`,
              },
            ]}
          >
            {!image && <span>Kein Bild verfügbar</span>}
          </div> */}
          {!!image ? (
            <img src={backgroundImageUrl} alt="" width={IMAGE_WIDTH} />
          ) : (
            <div style={[styles.imageWrapper, styles.imageWrapperMissing]}>
              <span>Kein Bild verfügbar</span>
            </div>
          )}
          <div style={styles.meta}>
            <div style={styles.title}>
              {title} {statusComponent}
            </div>
            <div style={styles.createdAt}>
              erstellt am {moment(createdAt).format('DD. MMMM YYYY - HH:mm')}
            </div>
            <div style={styles.description}>{ellipsify(description, 120)}</div>
          </div>
          <div style={styles.interactions}>
            {likesCount !== undefined && (
              <IconText icon="icon-heart" color="success" text={likesCount} />
            )}
            <IconText icon="icon-bubble" color="primary" text={commentsCount} />
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  root: {
    backgroundColor: Colors.White,
    marginBottom: Spacing.Micro,
    padding: Spacing.Micro,
    borderWidth: 1,
    borderColor: Colors.DarkGrey,
    borderStyle: 'solid',
  },
  content: {
    display: 'flex',
  },
  imageWrapper: {
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  imageWrapperMissing: {
    backgroundColor: Colors.DarkGrey,
    borderWidth: 2,
    borderColor: Colors.LightGrey,
    borderStyle: 'dashed',
  },
  meta: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: Spacing.Micro,
    flexShrink: 1,
    flexGrow: 1,
    marginRight: Spacing.Micro,
  },
  interactions: {
    flexShrink: 0,
    width: 60,
  },
  title: {
    fontSize: 18,
  },
  createdAt: {
    fontSize: 14,
    color: Colors.LightGrey,
  },
  description: {
    marginTop: Spacing.Micro,
    whiteSpace: 'pre-wrap',
  },
};

export default Radium(ImageTextListItem);



// WEBPACK FOOTER //
// ./src/components/ImageTextListItem/ImageTextListItem.js